import { itemFinancialsByItemIdsResponseSchema } from '@tempo-io/reporting-store-dto';
import { fetchChunksWithConcurrencyLimit } from '@/common/api/chunkedFetch';
import { REPORTING_STORE_API_BASE } from '@/common/api/reporting-store/constants';
import { tempoApi } from '@/common/api/tempoApi';
import { chunkBy } from '@/common/utils/chunkBy';

const BULK_FETCH_PAGE_SIZE_LIMIT = 100;

const fetchBatch = async (itemIds: number[], signal?: AbortSignal) => {
  const response = await tempoApi()
    .post(`${REPORTING_STORE_API_BASE}/financials/by-item-ids`, { json: itemIds, signal })
    .json();

  return itemFinancialsByItemIdsResponseSchema.parse(response).data;
};

const getItemFinancialsAggregate = async (itemIds: number[], signal?: AbortSignal) => {
  if (itemIds.length === 0) return [];
  if (itemIds.length <= BULK_FETCH_PAGE_SIZE_LIMIT) return fetchBatch(itemIds, signal);

  const batches = await fetchChunksWithConcurrencyLimit(
    chunkBy(itemIds, BULK_FETCH_PAGE_SIZE_LIMIT),
    (batch) => fetchBatch(batch, signal),
  );
  return batches.flat();
};

export const ItemFinancialsAggregateApi = {
  getItemFinancialsAggregate,
} as const;
